function slider_init() {
	
	var posters = jQuery( '.poster' ).length;
	var total = parseInt( posters ) - 7;
	
	if ( jQuery( window ).width() >= 1026 ) {
		
		var total = parseInt( posters ) - 7;
		
	}
	
	if ( jQuery( window ).width() < 1026 && jQuery( window ).width() > 760 ) {
		
		var total = parseInt( posters ) - 5;
		
	}
	
	if ( jQuery( window ).width() <= 760 ) {
		
		var total = parseInt( posters ) - 3;
		
	}
	
	jQuery( '#slider-input' ).attr( 'max', total );
	
}

function slider_sync( value ) {
	
	jQuery( '.work-feed' ).slick( 'slickGoTo', value );
	
}


jQuery(document).ready(function(){ 
	slider_init();
});


jQuery(window).on('resize', function(){
    slider_init();
});

jQuery( document ).on( 'input', '#slider-input', function() {
	
	var amount = jQuery( this ).val();
	
	slider_sync( amount );
		
});

jQuery( '.work-feed' ).on( 'swipe', function( event, slick, direction ) {
  
  if ( direction == "left" ) {
	  
	  var current_val = jQuery( '#slider-input' ).val();
	  var new_val = parseInt( current_val ) + 1;
	  
	  jQuery( '#slider-input' ).val( new_val );
	  
  }
  
    if ( direction == "right" ) {
	  
	  var current_val = jQuery( '#slider-input' ).val();
	  var new_val = parseInt( current_val ) - 1;
	  
	  jQuery( '#slider-input' ).val( new_val );
	  
  }
  
});

jQuery( "#slider-input" ).mouseup( function() {
	
 	var amount = jQuery( this ).val();
	
	slider_sync( amount );
  
});